<template>
  <div class="terms-container">
    <div class="z11 uppercase">CLARIFICATION TEXT ABOUT THE COMMUNICATIONS</div>

    <p class="z11">
      As ARTFIELD REKLAM İLETİŞİM ANONİM ŞİRKETİ (“Company”) acting in the capacity of Data Controller,
      in order to fulfill our obligation of providing clarification, arising from article 10 of the Personal
      Data Protection Law numbered 6698 (“PDPL”), we would like to provide you with information about your personal
      data processed within the scope of the communication including specifically our call center and online support.
    </p>

    <div class="z11 uppercase">1. YOUR PERSONAL DATA PROCESSED BY US AND PURPOSES OF PROCESSING</div>

    <p class="z11">
      We give utmost priority to the privacy and security of your personal data. Your personal data collected
      by Artfield through the communication channels including specifically its call center and online support
      services, such as identity information (name, surname), contact details (phone number, e-mail address, residence
      address), visual and audio records (audio records of the call center), customer transaction details (order and
      delivery number, request, suggestions, and complaints) and other information you shared during the communication
      will be processed for the purpose of executing communication activities, monitoring the requests and complaints,
      carrying out necessary inquiries and investigations to provide the support services demanded by the customer,
      providing you with information and support as needed, executing the processes regarding customer and seller
      relations management, obtaining and evaluating the suggestions made or the improvement of business processes,
      carrying out activities in connection with customer and seller satisfaction, and using as evidence in future
      disputes.
    </p>

    <p class="z11">
      Based on the following legal reasons regulated in the 2nd paragraph of article 5 of PDPL: “Data processing is
      necessary to preserve the legitimate interests of the Data Controller, provided that no harm is given to the
      fundamental rights and freedoms of the relevant data owner” and “Data processing is necessary for the purpose of
      establishing, exercising, or protecting a right.”
    </p>

    <p class="z11">
      Limited with the purposes detailed above, your personal data will be shared with our business partners from which
      we get support in our customer services and also with our suppliers, group companies, and with the authorized
      establishments and institutions or judicial authorities upon their request to be made in accordance with the
      legal arrangements and applicable legislation so that we can fulfill our legal obligations. Your personal data
      will be processed anonymously without any inquiry to the specific data owner for the purpose of improving and
      developing the online support texts as well as request and complaint processes and providing language support.
      Your personal data will also be shared with suppliers providing support in the area of artificial intelligence.
    </p>

    <div class="z11 uppercase">2. YOUR RIGHTS TO BE EXERCISED TO ENSURE PROTECTION OF YOUR PERSONAL DATA</div>

    <p class="z11">
      Pursuant to PDPL and applicable legislation, you have the rights detailed below in connection with your personal data:
    </p>
    <ul class="z11">
      <li>Learning whether your personal data has been processed or not.</li>
      <li>Demanding information on the processed data if your personal data was processed.</li>
      <li>Learning the specific purpose of processing your personal data and whether the data was used in accordance with this purpose.</li>
      <li>Knowing the identity of the third persons to whom your personal data was communicated in and out of the country.</li>
      <li>If your personal data was processed incompletely or inaccurately, requesting correction of the same.</li>
      <li>Requesting deletion or destruction of your personal data in line with the provisions of the PDPL legislation.</li>
      <li>If you request correction of incomplete or inaccurate data or deletion/destruction of your personal data, requesting that this operation be informed to the third persons to whom we communicated your personal data.</li>
      <li>If your personal data was processed unlawfully and you incur losses due to that reason, claiming recovery of these losses.</li>
    </ul>

    <div class="z11 uppercase">3. HOW TO COMMUNICATE WITH US FOR YOUR RIGHTS AND REQUESTS</div>

    <p class="z11">
      You may forward to our Company your questions and requests in line with the “Communique on the Methods and
      Principles for Applications to the Data Controller” and through your e-mail address recorded for your membership
      registered in our system to the following e-mail address: <strong>contact@artfieldofficial.com</strong>. Our Company
      will finalize your request at latest within 30 (thirty) days on a free-of-charge basis. However, if the response
      to be given to your application requires us to incur certain costs payable under the applicable legislation, the
      fee indicated on the tariff determined by the Personal Data Protection Board may be collected from you.
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  console.log('Terms of Service page loaded.');
});
</script>

<style scoped>
.z11:first-child {
  font-size: 20px;
}
.z11 {
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
}

.uppercase {
  text-transform: uppercase;
  margin-top: 20px;
  line-height: 20px;
  letter-spacing: .4px;
}
</style>
